import React from "react";
import { FilterState, ImportMode } from "../types";

interface FilterSectionProps {
  filterState: FilterState;
  mode: ImportMode;
  onSearchTextChange: (value: string) => void;
  onStartDateChange: (value: string) => void;
  onEndDateChange: (value: string) => void;
  onClearFilters: () => void;
}

export default function FilterSection({
  filterState,
  mode,
  onSearchTextChange,
  onStartDateChange,
  onEndDateChange,
  onClearFilters,
}: FilterSectionProps) {
  const { searchText, startDate, endDate } = filterState;

  const getSearchPlaceholder = () => {
    switch (mode) {
      case "eventTickets":
        return "Nom, lieu ou ville de l'évènement...";
      case "events":
        return "Nom, lieu ou ville de l'évènement...";
      default:
        return "Nom du projet, évènement, lieu ou ville...";
    }
  };

  return (
    <div className="border-b border-border pb-4 mb-4">
      <h3 className="text-sm font-medium mb-3">Filtres</h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
        {/* Search filter */}
        <div>
          <label className="block text-sm font-medium mb-2">Rechercher</label>
          <input
            type="text"
            placeholder={getSearchPlaceholder()}
            value={searchText}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onSearchTextChange(e.target.value)
            }
            className="w-full px-3 py-2 border border-border rounded-md bg-input text-primary text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 placeholder:text-tertiary"
          />
        </div>

        {/* Start date filter */}
        <div>
          <label className="block text-sm font-medium mb-2">
            Date de début
          </label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => onStartDateChange(e.target.value)}
            className="w-full px-3 py-2 border border-border rounded-md bg-input text-primary text-sm focus:outline-none focus:ring-2 focus:ring-primary/20"
          />
        </div>

        {/* End date filter */}
        <div>
          <label className="block text-sm font-medium mb-2">Date de fin</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => onEndDateChange(e.target.value)}
            className="w-full px-3 py-2 border border-border rounded-md bg-input text-primary text-sm focus:outline-none focus:ring-2 focus:ring-primary/20"
          />
        </div>
      </div>

      {/* Clear filters button */}
      {(searchText || startDate || endDate) && (
        <button
          onClick={onClearFilters}
          className="text-sm text-secondary hover:text-primary transition-colors mt-3"
        >
          Effacer les filtres
        </button>
      )}
    </div>
  );
}
